import styled from "styled-components";

export const HomeComponentContainer = styled.div`
  padding-top: 8rem;
  overflow-y: hidden;
`;

export const GreenOpacity = styled.div`
  width: 100%;
  height: 100%;
  background-color: rgba(159, 192, 136, 0.2);
`;
